<template>
  <SlideSidebarContainer>
    <template #title>
      <span>menu</span>
    </template>

    <MainMenuNavbar vertical />
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import MainMenuNavbar from '@/components/layout/menu/MainMenuNavbar'

  export default {
    components: {
      SlideSidebarContainer,
      MainMenuNavbar
    }
  }
</script>